enum AppConfig {
  Title = 'me.lemon.io',
  ReleaseYear = 2021,
}

export const muiLicense = ((): string => {
  const license = process.env.NEXT_PUBLIC_MUI_LICENSE;
  if (!license) {
    throw new Error(
      'The NEXT_PUBLIC_MUI_LICENSE variable in .env could not be discovered.'
    );
  }
  return license;
})();

export default AppConfig;
